module.exports = __webpack_public_path__ + "static/apple-icon-180x180.ba2e0e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/apple-icon-180x180.png
// module id = 375
// module chunks = 114276838955818